function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isType } from './../actions/actions';
import { ReceiveUserFavouriteDataAction, UpdateUserFavouriteFetchDataStatusAction, UpsertUserFavouriteItemAction, DeleteUserFavouriteItemAction, FavouriteAppsPricingDataReceivedAction } from './../actions/userFavouriteActions';
import { initialUserFavouriteState, copyState } from '@src/State';
import { isApplication, isConsultingService, getFavouriteEntityState, upsertsUserFavouriteEntityState, deleteUserFavouriteEntityState } from './../utils/userFavouriteUtils';
import { Constants } from './../utils/constants';
import { loadAppPricing } from './../utils/pricing';
export default function userFavouriteReducer(state = initialUserFavouriteState, action) {
    const newState = copyState(state);
    if (isType(action, ReceiveUserFavouriteDataAction)) {
        const payload = action.payload;
        const userFavourites = payload.userFavorites || [];
        userFavourites.forEach((userFavourite)=>{
            if (isApplication(userFavourite.applicationType)) {
                newState.apps = getFavouriteEntityState(userFavourite.favorites, userFavourite.applicationType);
            } else if (isConsultingService(userFavourite.applicationType)) {
                newState.services = getFavouriteEntityState(userFavourite.favorites, userFavourite.applicationType);
            }
        });
    } else if (isType(action, UpdateUserFavouriteFetchDataStatusAction)) {
        const payload = action.payload;
        if (newState.fetchDataStatus === payload.fetchDataStatus) {
            return state;
        }
        newState.fetchDataStatus = payload.fetchDataStatus;
    } else if (isType(action, UpsertUserFavouriteItemAction)) {
        if (newState.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid) {
            const payload = action.payload;
            if (isApplication(payload.applicationType)) {
                upsertsUserFavouriteEntityState(newState.apps, payload);
            } else if (isConsultingService(payload.applicationType)) {
                upsertsUserFavouriteEntityState(newState.services, payload);
            }
        }
    } else if (isType(action, DeleteUserFavouriteItemAction)) {
        if (newState.fetchDataStatus === Constants.UserFavourite.FetchDataStatus.Valid) {
            const payload = action.payload;
            if (isApplication(payload.applicationType)) {
                deleteUserFavouriteEntityState(newState.apps, payload);
            } else if (isConsultingService(payload.applicationType)) {
                deleteUserFavouriteEntityState(newState.services, payload);
            }
        }
    } else if (isType(action, FavouriteAppsPricingDataReceivedAction)) {
        if (!state.apps || !action.payload.pricingData || Object.keys(action.payload.pricingData).length === 0) {
            return state;
        }
        newState.apps = state.apps.map((favouriteApp)=>{
            const app = favouriteApp.item;
            const item = loadAppPricing(app, action.payload.pricingData);
            return _object_spread_props(_object_spread({}, favouriteApp), {
                item
            });
        });
    } else {
        return state;
    }
    return newState;
}
